import { useModulePermission } from '../../../hooks/usePermission';
import { Modules } from '../../../constants/permissions';

/**
 * N211 module permissions hook
 * PgCode = "pwn211f1"
 */
export function useN211Permissions() {
  return useModulePermission(Modules.N211);
}
